<template>
  <div>
    <div id="home">
      <div class="status">
        <span class="act">
          <i class="el-icon-check"></i>
        </span>
        <p></p>
        <span class="act">
          <i class="el-icon-check"></i>
        </span>
        <p></p>
        <span class="act">
          3
        </span>
      </div>
      <h1>그만두기 전 3달치 총 월급을 적어주세요.</h1>
      <el-input placeholder="0" v-model="formattedInput" @input="handleInput" style="width: 100%;margin-top: 30px;" type="text" inputmode="decimal">
        <template style="background-color: #ffffff;" slot="append">원</template>
      </el-input>
      <div class="error" v-if="errInput !== ''">
        <i class="el-icon-warning"></i>
        {{errInput}}
      </div>
      <div class="btn" @click="next()" :class="value !== ''?'btnAct':''">
        다음
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters, mapActions } from 'vuex'
  import moment from 'moment/moment';
  export default {
    name: 'Salary',
    components: {
    },
    data() {
      return {
        value:'',
        errInput:''
      }
    },
    computed: {
      formattedInput: {
        get() {
          return this.formatNumber(this.value);
        },
        set(value) {
          this.value = value;
        }
      }
    },
    created(){
      if(Vue.ls.get('salary'))
        this.value = Vue.ls.get('salary')
    },
    methods:{
      handleInput(value) {
        this.rawInput = value;
      },
      formatNumber(value) {
          let cleanValue = value.toString().replaceAll(',', '');
          let integerPart = cleanValue.split('.')[0];
          let numberValue = parseInt(integerPart, 10);
          if (isNaN(numberValue) || numberValue < 0) {
              return '';
          }
          return numberValue.toLocaleString('en-US');
      },
      next(){
        if(this.value !== ''){
          if(isNaN(this.value.replaceAll(',','')) || this.value.indexOf('.') !== -1){
            this.errInput='입력 형식이 잘못되었습니다.'
          }else{
            this.errInput = ''
            Vue.ls.set("salary", this.value.replaceAll(',',''))
            this.$router.push('/confirm')
          }
        }
      }
    }
  }
</script>

<style scoped>
  *{font-size:16px;font-size:inherit;box-sizing: border-box;margin:0px;padding:0px;}
  #home{height: 100vh;display: flex;flex-direction: column;width: 100%;padding:20px;}
  h1{color:#333333;font-size: 22px;}
  .btn{background:#EBECF0;color:#A8A8BC;display: flex;position: fixed;bottom:20px;justify-content: center;margin-top:30px;align-items: center;width: calc(100vw - 40px);height: 52px;border-radius: 26px;font-weight: bold;}
  .btnAct{background:#4873FF;color:#ffffff;}
  .status{display: flex;align-items: center;padding:40px;width: 100%;}
  .status span{width: 30px;height: 30px;display: flex;flex-shrink: 0;margin:0 10px;justify-content: center;align-items: center;color:#717B85;font-weight: bold;background-color: #EBECF0;border-radius: 50%;}
  .status .act{background-color: #C9D6FF;color: #003DFF;}
  .status p{background-color: #EDEEF2;height: 1px;width: 100%;}
  .errInput >>> .el-input__inner {background-color: #FFF3F3;border-color: #F20000;}
  .error{display: flex;align-items: center;color: #EC0000;font-size: 14px;margin-top: 10px;}
  .error i{margin-right: 5px;font-size: 18px;}
  >>> .el-input-group__append{background-color: #ffffff;padding:0 10px;}
</style>
